define('models/ProductCollection',['underscore', 'app', 'ObjectCollection', 'LocalStorage', 'models/ProductModel','models/StoreModel'],
    function (_, app, ObjectCollection, LocalStorage, ProductModel,StoreModel)
{
    //
    // Collection Product
    //
    var ProductCollectionPrototype = {

        name: 'ProductCollection',
        idAttribute: 'id_product',
        route: 'apiProductCollection',
        model: ProductModel,
        initialize: function ()
        {
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this, arguments);
            //
        },

        getProductsByIds: function (productsId, inContext, inContextBuyable, withFilters, cart)
        {
            var sourceCollection = this,
                productCollection = new ProductCollection();
            productCollection.reset();
            //
            withFilters = (!!withFilters) && !(app.getTags().isFilterChecked() && app.getAllergenGroups().isFilterChecked());
            //
            _(productsId).each(function(id){
                var product = sourceCollection.get(id);
                if(product){
                    if(withFilters && !product.isFiltred(cart)){
                        // si on a des filtres et que le produit n'est pas filtré
                        return;
                    }
                    if((!!inContext) && !cart){
                        cart = defaultCart(cart);
                    }
                    if ((!!inContext) &&
                        // inContextBuyable distingue un tri par visibilité ou par achetable
                        // par défaut, on est en visibilité
                        !(
                            inContextBuyable ? product.isBuyableInContext(cart) : product.isVisibleInContext(false,cart)
                        )) {
                        return;
                    }else
                    {
                        productCollection.models.push(product);
                        productCollection.length ++
                    }
                }
            });
            return productCollection;
        },
        inContext: function (inContextBuyable, cart)
        {
            var filtredCollection = this.filter(function(product){
                // inContextBuyable distingue un tri par visibilité ou par achetable
                // par défaut, on est en visibilité
                return inContextBuyable ? product.isBuyableInContext(cart) : product.isVisibleInContext(false,cart);
            });
            return new ProductCollection(filtredCollection);
        },
        clearSidedishes:function(){
            // fonction qui invalide les cross-selling (sidedish) lors de changement de contexte panier
            // ils seront automatiquement repeuplé via product.getSidedishes()
            this.each(function(product){
                delete product.sidedishes
            });
        }
    };

    function defaultCart(cart){
        return cart ? cart : app.getCart();
    }

    var ProductCollection = ObjectCollection.extend(LocalStorage).extend(ProductCollectionPrototype);

    return ProductCollection;
});
